import React, { Component } from 'react';
import { ReplacePrefixUrl, ReplaceText } from '../../config/helper';
import { FaRegFolder } from 'react-icons/fa';
import NAimage from '../../img/pic-na.png';

export default class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      title: '',
      category: '',
      excerpt: '',
      image: '',
      link: '',
      memberStatus: localStorage.getItem('status')
    }
  }

  componentDidMount() {
    var content = this.props.value;
    this.setState({
      id: content.id,
      image: (content.libraryPicture !== "" && content.libraryPicture !== undefined)? content.libraryPicture : NAimage,
      title: ReplaceText(content.libraryTitle),
      category: content.categoryName,
      excerpt: ReplaceText(content.libraryShortDesc),
      link: '/library/' + ReplacePrefixUrl(content.libraryTitle) + '/' + content.id
      // link: (this.state.memberStatus === 'Member' ? '/enroll/' : '/library/') + content.id
    });
  }
  
  render() {    
    return (
			<a href={this.state.link}>
        <div className="library-list row">
          <div className="col-md-3 text-center">
            <img className="rounded mx-auto" src={this.state.image} alt={"Library " + this.state.title}  style={{maxWidth: "150px"}}/>
          </div>
          <div className="col-md-9">
            <h5 className="mb-3">{this.state.title}</h5>
            <p>
              <FaRegFolder className="me-1"/>
              {this.state.category}
            </p>
            <p className="clamp-3">{this.state.excerpt}</p>
          </div>
        </div>
      </a>
    )
  }
}